import {ComponentStore} from '@ngrx/component-store';
import {MetricsConsentAutoCorrectionButtonState, MetricsConsentAutoCorrectionState} from './metricsConsentAutoCorrection';
import {AppState} from '../store';
import {Store} from '@ngrx/store';
import {Observable, Subscription, withLatestFrom} from 'rxjs';
import {tap} from 'rxjs/operators';
import {selectMetricsConsentAutoCorrectionState} from './metricsConsentAutoCorrection.selectors';
import {disableMetricsConsentAutoCorrection, enableMetricsConsentAutoCorrection} from './metricsConsentAutoCorrection.actions';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {Site} from '../../interfaces/site';
import {selectSite} from '../init/init.selectors';
import {Serializer} from '../../interfaces/serializer';
import {Injectable} from '@angular/core';

@Injectable()
export class MetricsConsentAutoCorrectionButtonStore extends ComponentStore<MetricsConsentAutoCorrectionButtonState> {
  private readonly _dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);
  private readonly _metricsAutoCorrectionState$: Observable<MetricsConsentAutoCorrectionState> = this._store.select(selectMetricsConsentAutoCorrectionState);

  public readonly loading$: Observable<boolean> = this.select((state: MetricsConsentAutoCorrectionButtonState): boolean => state.loading);
  public readonly disabled$: Observable<boolean> = this.select((state: MetricsConsentAutoCorrectionButtonState): boolean => state.disabled);

  public readonly autocorrectToggle: () => void = this.effect((params$: Observable<void>): Observable<[void, MetricsConsentAutoCorrectionState,
    Serializer<Site>]> => params$.pipe(
    withLatestFrom(this._metricsAutoCorrectionState$, this._dataset$),
    tap(([_, metricsAutoCorrectionState, dataset]: [void, MetricsConsentAutoCorrectionState, Serializer<Site>]): void => {
      switch (metricsAutoCorrectionState.status) {
        case 'on':
          this._store.dispatch(disableMetricsConsentAutoCorrection());
          break;
        case 'off':
          this._store.dispatch(enableMetricsConsentAutoCorrection({
            default_rate: dataset.attributes.parameters.auto_correct_consent.default_rate
          }))
          break;
        case 'not-configured':
          this._router.navigate([`/${ dataset.id }/metrics/consent-auto-correction`]);
          break;
      }
    })
  ));

  private readonly _initDisabled$: Subscription = this.effect(() => this._route.data.pipe(
    tap((data: Data): void => {
      this.patchState({
        disabled: ['affinity', 'path-explorer', 'transaction-id'].includes(data['reportType'])
      });
    })
  ));

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _router: Router,
    private readonly _route: ActivatedRoute
  ) {
    super({
      disabled: false,
      loading: false
    });
  }

}
